<script lang="ts" setup>
import { storeToRefs } from "pinia";

import AddObjectSelect from "./add-object-select.vue";

import { useComparisonConfigStore } from "@/config/config-store";

const configStore = useComparisonConfigStore();
const { fontSize } = storeToRefs(configStore);
</script>

<template>
  <div class="flex flex-col items-center justify-center px-6 py-16 text-center">
    <i class="pi pi-table mb-4 text-5xl text-gray-300" />
    <p
      class="mb-2 text-lg font-semibold text-gray-600"
      :style="{ fontSize: `${fontSize + 2}px` }"
    >
      Geen objecten geselecteerd
    </p>
    <p
      class="mb-6 text-sm text-gray-400"
      :style="{ fontSize: `${fontSize}px` }"
    >
      Voeg objecten toe om de vergelijking te starten.
    </p>
    <AddObjectSelect class="w-64" size="small" />
  </div>
</template>
